///<reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.Teachers {
    angular.module('meevo.plugins.teachers', []);
}